module.exports = __webpack_public_path__ + "img/wartung.e660e5da.png";